import React, {useContext} from "react";
import {useUserContext} from "../../providers/userProvider/user-context.tsx";
import {ThemeContext} from "../../providers/themeContext/theme-context.tsx";
import {isEmptyOrNullOrUndefined} from "../../common/utils/Datautil.ts";


type Props = {
    className?: string,
    onClick?: () => void,
}

// 自己的头像组件，方便统一管理
const Avatar: React.FC<Props> = ({className, onClick}) => {
    // 全局用户信息provider
    const {user} = useUserContext();
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);


    return <div onClick={onClick}
                className={`position-relative ${className} display-flex-column display-flex-align-items-center display-flex-justify-content-center`}>
        {/*头像*/}
        <img
            className="bg-img-cover-no-repeat-center width-100-percent height-100-percent border-radius-round bg-color-white object-fit-contain"
            style={user?.avatarFrame ? {height: '90%', width: '90%'} : {padding: '1px'}}
            src={ user?.cgtnAvatar ?? imgUrls.defaultAvatarUrl} alt="avatar"/>
        {/*头像框*/}
        {!isEmptyOrNullOrUndefined(user?.avatarFrame) &&
            <img
                className="bg-img-cover-no-repeat-center width-100-percent height-100-percent position-absolute object-fit-contain"
                src={user?.avatarFrame} alt="frame"/>}

    </div>;
};

export default Avatar;